// Newlines glued to a BLOCK boundary only render as an empty <br>. Inline tags are left
// alone on purpose: villa rules do carry meaningful breaks right after a <strong>.
const BLOCK_TAGS = 'p|div|li|ul|ol|h[1-6]|blockquote';
const NEWLINE_AFTER_BLOCK_OPEN = new RegExp(
  `(<(?:${BLOCK_TAGS})\\b[^>]*>)\\s*\\n+`,
  'gi',
);
const NEWLINE_BEFORE_BLOCK_CLOSE = new RegExp(
  `\\n+\\s*(</(?:${BLOCK_TAGS})>)`,
  'gi',
);

/**
 * Villa rules and notes are authored in a rich text editor: a block means a paragraph
 * gap, a newline inside it means a plain line break.
 */
export function formatRichText(html?: string | null): string {
  if (!html) return '';

  return html
    .replace(/\r\n|\r/g, '\n')
    .replace(NEWLINE_AFTER_BLOCK_OPEN, '$1')
    .replace(NEWLINE_BEFORE_BLOCK_CLOSE, '$1')
    .replace(/^\s*\n+|\n+\s*$/g, '')
    .replace(/\n/g, '<br />');
}
